// extracted by mini-css-extract-plugin
export default {"base":"Gycey","content":"ZqnHL","embedArea":"I0Xb1","large":"_soqy","demoOverlay":"NK8By"};